module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClass,
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.isVertical && ((_vm.label && _vm.label.length > 0) || _vm.icon.length > 0)) ? _c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.hasIcon) ? _c('i', {
    staticClass: "zmdi",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.hasLabel) ? _c('span', {
    staticClass: "gray",
    class: {
      'p-10': _vm.hasIcon
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fg-line",
    class: {
      'fg-toggled': _vm.ifocus
    }
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.isOnFocus),
      expression: "isOnFocus"
    }],
    staticClass: "form-control",
    style: ({
      'background-color': (_vm.isReadOnly && !_vm.isVertical) ? '#FFF' : ''
    }),
    attrs: {
      "type": _vm.type,
      "placeholder": !_vm.isVertical ? _vm.placeholder : '',
      "disabled": !_vm.isEnabled,
      "readonly": _vm.isReadOnly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "focus": _vm._p_focus,
      "blur": _vm._p_blur
    }
  }), _vm._v(" "), (_vm.isVertical) ? _c('label', {
    staticClass: "fg-label"
  }, [(_vm.hasIcon) ? _c('i', {
    staticClass: "zmdi",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.validator) ? _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasValidFail),
      expression: " hasValidFail "
    }],
    staticClass: "zmdi zmdi-alert-triangle form-control-feedback",
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "data-placement": "bottom"
    }
  }), _vm._v(" "), (_vm.hasValidSuccess) ? _c('span', {
    staticClass: "zmdi zmdi-check form-control-feedback",
    staticStyle: {
      "width": "5px"
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5900820"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/textbox.vue
// module id = 558
// module chunks = 23